<template>
    <div class="card-data mini" :class="id==activeId ? 'active': ''">
        <button class="expand" @click="$emit('selectCluster', {'cluster':cluster, 'venues': venues,'id':id})">
            <i class="icon ico-expand"></i>
        </button>
        <div class="card-title">
            <h5 class="title">{{cluster}}</h5>
            <div class="venues">
                <i class="icon ico-venue"></i>
                <small class="venue">{{thousandseparatos(venues)}} sedes</small>
            </div>
        </div>
        <div v-if="loader" class="chart">
            <apexchart class="apex" type="line" height="64" :options="chartOptions" :series="data"></apexchart>
            <div class="revenue">
                <p class="title">Conexiones</p>
                <p class="amount">{{thousandseparatos(totalRevenue)}}</p>
            </div>
        </div>
        <Loader v-else/>
    </div>
    
</template>

<script>

import Loader from '@/components/Loader'

export default {
    name: 'MinilineChartCard',
    components: {
        Loader,
    },
    props: {
        loader: {
            type: Boolean,
            required: true
        },
        cluster: {
            type: String,
            required: true
        },
        venues: {
            type: Number,
            required: false
        },
        totalRevenue:{
            type: Number,
            // default: "123.456"
        },
        data:{
            type: Array
        },
        periodItems:{
            type: Array
        },
        id:{
            type: Number,
            required: true
        },
        activeId:{
            type: Number,
            required: false
        }
    },
    data(){
        return{
            expand: false,
        }
    },
    computed:{
        chartOptions: function() {
            return {    
                chart: {
                    height: "100%",
                    width: "100%",
                    type: "line",
                    parentHeightOffset: 0,
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: true
                    },
                    animations: {
                        enabled: false
                    }
                },
                stroke:{
                    curve: "smooth",
                    lineCap: 'round',
                    width: 3,
                },
                dataLabels: {
                    enabled: false
                },
                // colors: ,
                xaxis: {
                    type: 'categories',
                    categories: this.periodItems,
                    labels: {
                        show: false,
                    },
                    axisTicks:{
                                show: false,
                            },
                    tooltip: {
                        enabled: false
                    },
                },
                yaxis:{
                    show: false
                },
                fill: {
                    opacity: 1
                },
                tooltip:{
                    enabled: false
                },
                grid:{
                    show: true,
                    padding:{
                        left: 8,
                        right: 8,
                        top: -10,
                        bottom: -10,
                    },
                },
            }
        }
    },
    methods: {
        thousandseparatos: function(num){
            try {
                let num_parts = []
                num = parseInt(num)
                if (num > 999999){
                  num = ((num / 1000000).toFixed(1))
                  num_parts = num.toString().split(".");
                  num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  num_parts = num_parts.join(".");
                  num_parts = num_parts+" MM"
                }else{
                  num_parts = num.toString().split(".");
                  num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  num_parts = num_parts.join(".");
                }

                return num_parts
            } catch (error) {
                return error
            }
        },
    },
}
</script>

<style lang="sass">
.invalid-display
    display: block
    max-width: 220px
    max-height: 220px
    margin: 12px auto 
.invalid-display-text
    width: 100%
    margin-bottom: 8px
    display: block
    font-family: Muli
    font-size: 16px
    text-align: center
    color: #302f2f
@include mobile
    .apexchart
        div
            background: $lighter-grey
            border-radius: 8px
            margin-bottom: 8px
.card-data.mini
    padding-bottom: 8px
    opacity: 0.8
    &.active
        opacity: 1
    .card-title h5
        margin-top: $xs
    button.expand
        background: $lighter-grey
        border-radius: 2px
        border: none
        padding: 2px
        position: absolute
        top: 8px
        right: 8px
        width: 20px
        height: 20px
        cursor: pointer
        color: $dark-grey
        &:hover
            background: $default
            color: $secondary
        .icon
            font-size: 16px
            margin: 0
    .venues
        margin-top: $xxs
        background: $default
        max-width: 128px
        border-radius: $xxs
        box-sizing: border-box
        padding: 2px $xxs 
        display: flex
        aling-items: center
        color: $dark
        .icon
            height: 16px
            width: 16px
            color: $dark
            font-size: 16px
            margin: 0
        .venue
            margin-left: $xxs
    .chart
        width: 100%
        background: $lighter-grey
        margin-top: $sm
        display: flex
        height: 64px
        border-radius: 4px
        overflow: hidden
        .apex
            width: 65%
        .revenue
            width: 45%
            height: 100%
            text-align: right
            padding-right: $xs
            display: flex
            flex-direction: column
            justify-content: space-around
            align-items: flex-end
            font-family: $title-font
            font-size: 14px
            font-weight: 600
            .title
            .amount

</style>